import * as React from 'react';

import { Collapse as CollapseComponent } from 'react-collapse';

import './Collapse.scss';

interface CollapseProps {
  isOpen: boolean;
}

export class Collapse extends React.Component<CollapseProps, {}> {
  render() {
    const { children, isOpen } = this.props;
    return (
      <CollapseComponent isOpened={isOpen}>
        {children}
      </CollapseComponent>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Collapse/Collapse.tsx